import { useState } from "react";
import { useNavigate, useSearchParams, Link } from "react-router-dom";
import { KeyRound, CheckCircle2 } from "lucide-react";
import api from "../lib/api";
import Header from "../components/Header";
import Footer from "../components/Footer";

export default function ResetPassword() {
  const navigate = useNavigate();
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const [pw, setPw] = useState("");
  const [pw2, setPw2] = useState("");
  const [loading, setLoading] = useState(false);
  const [done, setDone] = useState(false);
  const [err, setErr] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setErr("");
    if (pw.length < 6) return setErr("Lösenordet måste vara minst 6 tecken");
    if (pw !== pw2) return setErr("Lösenorden matchar inte");
    setLoading(true);
    try {
      await api.post("/auth/reset-password", { token, new_password: pw });
      setDone(true);
      setTimeout(() => navigate("/photographer/login"), 2500);
    } catch (e) {
      setErr(e?.response?.data?.detail || "Återställning misslyckades. Begär en ny länk.");
    } finally {
      setLoading(false);
    }
  };

  if (!token) {
    return (
      <div className="App">
        <Header />
        <div className="max-w-md mx-auto px-4 py-16">
          <p className="text-white/80">Ogiltig återställningslänk.</p>
          <Link to="/forgot-password" className="text-brand hover:underline">Begär en ny länk</Link>
        </div>
        <Footer />
      </div>
    );
  }

  return (
    <div className="App">
      <Header />
      <div className="max-w-md mx-auto px-4 py-16">
        <KeyRound className="w-10 h-10 text-brand mb-4" />
        <p className="label-overline mb-2">Nytt lösenord</p>
        <h1 className="font-display font-black uppercase text-white text-4xl mb-6">Välj nytt lösenord</h1>

        {done ? (
          <div className="card-surface p-6 space-y-3" data-testid="reset-success">
            <div className="flex items-center gap-3 text-brand">
              <CheckCircle2 className="w-6 h-6" />
              <p className="font-display font-bold uppercase">Lösenordet är uppdaterat</p>
            </div>
            <p className="text-white/70 text-sm">Du skickas vidare till inloggningen...</p>
          </div>
        ) : (
          <form onSubmit={submit} className="card-surface p-6 space-y-4" data-testid="reset-form">
            <div>
              <label className="label-overline block mb-1">Nytt lösenord</label>
              <input
                type="password"
                required
                minLength={6}
                value={pw}
                onChange={(e) => setPw(e.target.value)}
                className="input-field"
                data-testid="reset-pw"
              />
            </div>
            <div>
              <label className="label-overline block mb-1">Bekräfta lösenord</label>
              <input
                type="password"
                required
                minLength={6}
                value={pw2}
                onChange={(e) => setPw2(e.target.value)}
                className="input-field"
                data-testid="reset-pw2"
              />
            </div>
            {err && <p className="text-destructive text-sm" data-testid="reset-error">{err}</p>}
            <button type="submit" disabled={loading} className="btn-primary w-full" data-testid="reset-submit">
              {loading ? "Sparar..." : "Spara nytt lösenord"}
            </button>
          </form>
        )}
      </div>
      <Footer />
    </div>
  );
}
